/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
import { useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";

import { ROUTES } from "Router";
import { getEventId } from "Router/RoutesUtils";

import { useAuth } from "state";

import { Logo } from "components/icons";

import { EmailVerification, ForgetPasswordForm } from "./components";
import ResetPassword from "./components/ResetPassword/ResetPassword";
import s from "./style.module.css";
import MetaTitle from "components/ui/MetaTitle";
import Stack from "components/ui/Stack";

const ForgetPasswordPage = () => {
  const [currentForm, setCurrentForm] = useState("forget_password");
  const [email, setEmail] = useState("");
  const { isLoggedIn } = useAuth();
  const navigate = useNavigate();
  useEffect(() => {
    if (isLoggedIn) {
      const eventId = getEventId();
      if (eventId) {
        window.location.replace(ROUTES.HOME + `${eventId}`);
      } else {
        navigate(ROUTES.BASE);
      }
    }
  }, [isLoggedIn, navigate]);

  const formsMapper = {
    forget_password: (
      <ForgetPasswordForm setCurrentForm={setCurrentForm} setEmail={setEmail} />
    ),
    reset_password: <ResetPassword />,
    verification_code: (
      <EmailVerification setCurrentForm={setCurrentForm} email={email} />
    ),
  };

  return (
    <>
      <MetaTitle title={`Forget Password`} test-id="3WsC7kUC" />

      <Stack className={s.root}>
        <div className="!mb-8">
          <Logo className={s.logo} />
        </div>
        {formsMapper[currentForm as keyof typeof formsMapper]}
      </Stack>
    </>
  );
};

export default ForgetPasswordPage;
